import { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Header from './Header';
import Sidebar from './Sidebar';
import HorizontalBar from './HorizontalBar';
import MainContentStyled from './MainContentStyled';
import Loader from 'ui-component/Loader';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import FadeInWhenVisible from 'views/pages/Animation';

import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// types
import { MenuOrientation } from 'types/config';
import Footer from './Footer';
import { ThemeMode } from 'types/config';
import GameSection from '../../views/pages/home/GameSection';
import BannerDashBoard from 'ui-component/banner/BannerDashBoard';
import CardSection from 'ui-component/cards/CardSection';
import SubCardSection from 'ui-component/cards/SubCardSection';
import TopRatedGames from './TopRatedGames';
import GameProviders from 'ui-component/gameproviders/GameProviders';
import HorseRacingFixed from './HorseRacingFixed';
import Customization from 'layout/Customization';
import { useParams } from 'react-router-dom';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const { providerId } = useParams();

    const downMD = useMediaQuery(theme.breakpoints.down('md'));

    const { borderRadius, container, miniDrawer, menuOrientation } = useConfig();
    const { menuMaster, menuMasterLoading } = useGetMenuMaster();
    const [marbleRacing, setMarbleRacing] = useState(0);
    const drawerOpen = menuMaster?.isDashboardDrawerOpened;
    const excludedProviders = ['evo', 'fc', 'jdb', 'softquo', 'vgs', 'jili', 'pragmatic', 'dgx', 'kc', 'ibtwn'];

    useEffect(() => {
        handlerDrawerOpen(!miniDrawer);
    }, [miniDrawer]);

    useEffect(() => {
        downMD && handlerDrawerOpen(false);
    }, [downMD]);

    useEffect(() => {
        if (location.pathname.includes('marbleracing')) {
            setMarbleRacing(1);
        } else {
            setMarbleRacing(0);
        }
    }, [location.pathname]);

    const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

    // horizontal menu-list bar : drawer
    const menu = useMemo(() => (isHorizontal ? <HorizontalBar /> : <Sidebar />), [isHorizontal]);

    if (menuMasterLoading) return <Loader />;
    return (
        <Box
            sx={{
                display: 'flex',
                backgroundColor: '#121212'
            }}
        >
            <Container>
                {/* header */}
                <AppBar
                    enableColorOnDark
                    position="fixed"
                    color="inherit"
                    elevation={0}
                    // sx={{ bgcolor: 'background.default' }}
                    sx={{
                        boxShadow: '0px 0px .625rem 0px rgba(0,0,0,0.75)',
                        backdropFilter: 'blur(6px)',
                        background: '#ffffff05'
                        // bgcolor: 'background.default'
                        // background: '#1a654a',
                        // backgroundColor: theme.palette.dark[800]
                        // backgroundColor: theme.palette.blue[100]
                        // backgroundColor: theme.palette.mode === ThemeMode.DARK ? theme.palette.dark[800] : theme.palette.common.white,
                        // backgroundColor: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[50] : theme.palette.common.white,
                    }}
                >
                    <Toolbar sx={{ p: isHorizontal ? 1.25 : 2, gap: '4px', [theme.breakpoints.down('sm')]: { gap: '2px' } }}>
                        <Header />
                    </Toolbar>
                </AppBar>

                {/* menu / drawer */}
                {/* {menu} */}

                {/* main content */}
                <MainContentStyled {...{ borderRadius, menuOrientation, open: drawerOpen, theme }}>
                    <Outlet />
                    <Box
                        sx={{
                            mt: 1,
                            py: 8.5,
                            paddingTop: '0px',
                            flexDirection: 'column',
                            display: 'flex',
                            // backgroundColor:  theme.palette.dark[800],
                            pb: 0
                        }}
                    >
                        {!excludedProviders.includes(providerId) && !marbleRacing && <Footer />}
                    </Box>
                </MainContentStyled>

                {/* <Customization /> */}
            </Container>
        </Box>
    );
};

export default MainLayout;
